export { UserMoveAlt as default } from './UserMoveAlt';
